module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/landing-packages"
    }
  }, [_vm._v("Paket Landing Page")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/landing-banners"
    }
  }, [_vm._v("Banner Landing Page")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/android-banners"
    }
  }, [_vm._v("Banner Android")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/webapp-banners"
    }
  }, [_vm._v("Banner Webapp")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', [_vm._v("OSS Configs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b9d89d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/Navigation.vue
// module id = 2234
// module chunks = 1